<template>
  <div >
      <b-card>
        <template v-if="title.includes('Entries')">
            <b-row class="infoBlock">
                <b-col lg='6' sm="12" v-if="hasSponsPlayer || hasAmaPlayers || hasEntSponsPlayer">
                    <div class="inforBreak" v-if="hasSponsPlayer">
                        <b-img
                            class="tLogo"
                            :src="
                            'https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2021/03/titleist_oom-copy.png'
                            "
                        ></b-img
                        ><span> Indicates Golf Ball Usage</span>
                    </div>
                    <div v-if="hasAmaPlayers">
                        <div class="SecondLine" style="margin-top:10px">(a) Denotes an Amateur Player</div>
                    </div>
                    <div v-if="hasEntSponsPlayer"><img style="width:20px" src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"> = Denotes players who have already earned exemptions into The Open Championship</div>
                </b-col>
                <b-col v-if="showGender == 'Y'" lg='6' sm="12">
                    <div class="inforBreak" >
                        <span v-if="tourID !== 'wpg'"
                        >
                            <span class="female">•</span>
                            <span class="multiName"> 
                                <span class="nameMulti"> <span class="multiText">Female</span></span>
                            </span>
                        </span>
                        <span v-else
                        >
                            <span class="male">•</span>
                            <span class="multiName"> 
                                <span class="nameMulti"> <span class="multiText">Male</span></span>
                            </span>
                        </span>
                    </div>
                </b-col>
            </b-row>
        </template>
        <template v-if="title.includes('Draw')">
            <b-row class="infoBlock">
                <b-col lg='6' sm="12">
                    <div >
                        <div class="SecondLine">(a) Denotes an Amateur Player</div>
                    </div>
                    <div v-if="hasEntSponsPlayer"><img style="width:20px" src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"> = Denotes players who have already earned exemptions into The Open Championship</div>
                </b-col>
                <b-col v-if="showGender == 'Y'" lg='3' sm="12">
                    <div class="inforBreak" v-if="showGender == 'Y'">
                        <span v-if="tourID !== 'wpg'"
                        >
                            <span class="female">•</span>
                            <span class="multiName"> 
                                <span class="nameMulti"> <span class="multiText">Female</span></span>
                            </span>
                        </span>
                        <span v-else
                        >
                            <span class="male">•</span>
                            <span class="multiName"> 
                                <span class="nameMulti"> <span class="multiText">Male</span></span>
                            </span>
                        </span>
                    </div>
                </b-col>
            </b-row>
        </template>
        <template v-if="title.includes('Score')">
            <b-row class="infoBlock">
                <b-col lg='3' sm="12" :class="{'firstCol' : data.multi_course == 'N'}">
                    <div class="inforBreak" v-if="hasSponsPlayer">
                        <b-img
                            class="tLogo"
                            :src="
                            'https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2021/03/titleist_oom-copy.png'
                            "
                        ></b-img
                        ><span> Indicates Golf Ball Usage</span>
                    </div>
                    <div v-if="hasNonFirstTee" >
                        <div class="SecondLine">* Player did not start from 1st hole</div>
                    </div>
                    <div v-if="hasAmaPlayers">
                        <div class="SecondLine" style="margin-top:10px">(a) Denotes an Amateur Player</div>
                    </div>
                    <div class="infoBreak marginUp" v-if="rts == 'S'">
                    <!-- <div class="infoBreak marginUp" > -->
                        <span class="strokesColour"> 1,2,3 ect <span class="normalText">Shots played on current hole</span></span>
                    </div>
                    <div v-if="hasEntSponsPlayer" class="theOpen"><img style="width:20px" src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"> = Denotes players who have already earned exemptions into The Open Championship</div>
                    <div class="InforSection marginUp" v-if="data.fw_missed_lr == 'Y'">
                    <!-- <div class="InforSection marginUp" > -->
                        <span class="red">L</span> = Left Missed Fairway<br>
                        <span class="red">R</span> = Right Missed Fairway
                    </div>
                </b-col>
                <b-col lg="1" v-if="data.multi_course == 'Y' || showGender == 'Y'">
                    <div class="divider"></div>
                </b-col>
                <b-col v-if="data.multi_course == 'Y' || showGender == 'Y'" lg='2' sm="12">
                    <div class="infoBreak" v-if="data.multi_course == 'Y'">
                        <span
                            class="multiList"
                            v-for="(multi, index) in data.courses.courses_entry"
                            :key="index"
                        >
                            <span class="mutiDot" :class="multi.course_X_colour"></span>
                            <span class="multiName"> 
                                <span class="nameMulti" :class="multi.course_X_colour"> <span class="multiText">{{ multi.course_X_id }}</span></span>
                            </span>
                        </span>
                    </div>
                    <div class="inforBreak" v-if="showGender == 'Y'">
                        <span v-if="tourID !== 'wpg'"
                        >
                            <span class="female">•</span>
                            <span class="multiName"> 
                                <span class="nameMulti"> <span class="multiText">Female</span></span>
                            </span>
                        </span>
                        <span v-else
                        >
                            <span class="male">•</span>
                            <span class="multiName"> 
                                <span class="nameMulti"> <span class="multiText">Male</span></span>
                            </span>
                        </span>
                    </div>
                </b-col>
                <b-col lg="1">
                    <div class="divider"></div>
                </b-col>
                <b-col>
                    <b-row class="inforHoleWidth">
                        <b-col lg="4" sm="4">
                            <div class="hbhLink"><span class="multicourseDot vspar-albatross">•</span> Albatross</div>
                        </b-col>
                        <b-col lg="4" sm="4">
                            <div class="hbhLink"><span class="multicourseDot vspar-eagle">•</span> Eagle</div>
                        </b-col>
                        <b-col lg="4" sm="4">
                            <div class="hbhLink"><span class="multicourseDot vspar-birdie">•</span> Birdie</div>
                        </b-col>
                        <b-col lg="4" sm="4">
                            <div class="hbhLink"><span class="multicourseDot vspar-bogey">•</span> Bogey</div>
                        </b-col>
                        <b-col lg="4" sm="4">
                            <div class="hbhLink"><span class="multicourseDot vspar-dbogey">•</span> D. Bogey+</div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </template>
        <template v-if="title.includes('Resu')">
            <b-row class="infoBlock">
                <b-col lg='6' sm="12" v-if="hasSponsPlayer || hasAmaPlayers || hasEntSponsPlayer">
                    <div class="inforBreak" v-if="hasSponsPlayer">
                        <b-img
                            class="tLogo"
                            :src="
                            'https://ocs-sport.ams3.cdn.digitaloceanspaces.com/let_new/2021/03/titleist_oom-copy.png'
                            "
                        ></b-img
                        ><span> Indicates Golf Ball Usage</span>
                    </div>
                    <div v-if="hasAmaPlayers">
                        <div class="SecondLine" style="margin-top:10px">(a) Denotes an Amateur Player</div>
                    </div>
                    <div v-if="hasEntSponsPlayer"><img style="width:20px" src="https://assets.asiantour.com/asian-tour/2022/06/theopen.png"> = Denotes players who have already earned exemptions into The Open Championship</div>
                </b-col>
                <b-col v-if="showGender == 'Y'" lg='6' sm="12">
                    <div class="inforBreak" >
                        <span v-if="tourID !== 'wpg'"
                        >
                            <span class="female">•</span>
                            <span class="multiName"> 
                                <span class="nameMulti"> <span class="multiText">Female</span></span>
                            </span>
                        </span>
                        <span v-else
                        >
                            <span class="male">•</span>
                            <span class="multiName"> 
                                <span class="nameMulti"> <span class="multiText">Male</span></span>
                            </span>
                        </span>
                    </div>
                </b-col>
            </b-row>
        </template>

      </b-card>
  </div>
</template>
<script>
// import axios from "axios";
export default {
  name: "Information",
  props: [
    "data",
    "previousData",
    "home",
    "title",
    "report",
    "code",
    "season",
    "takeover",
    "config",
    "team",
    "match",
    "live",
    "RTCDS",
    "bbTeamEvent",
    "roundsplayed",
    "showGender",
    "Stableford",
    "rts",
    "currentReport",
    "hasAmaPlayers",
    "hasSponsPlayer",
    "hasEntSponsPlayer",
    "hasNonFirstTee"
  ],
  data() {
    return {
        tourID: process.env.VUE_APP_URL_TOUR,
    };
  },
};
</script>

<style scoped>
.marginUp {
    margin-top: 10px;
}
.col-sm-12.col-lg-3.firstCol {
    flex: 0 0 50%;
    max-width: 50%;
}
.theOpen {
    font-weight: 400;
    margin-top: 15px;
}
.divider {
    height: 100%;
    width: 1px;
    background-color: #D1D1D1;
}
.hbhLink {
    font-weight: 400;
}
.infoBreak {
    display: grid;
}
span.multiList {
    /* padding-bottom: 10px; */
}
.red {
    color: red;
    font-weight: bold;
}
.InforSection {
    padding-top: 20px;
}
.normalText {
    color: #000;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    margin-left: 20px;
}
.strokesColour {
    color: #3c9933 !important;
    font-weight: bold;
    font-style: italic; 
    font-size: 1rem;
}
.card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem;
    padding-top: 30px;
    border-bottom: 1px solid #faf9f9;
}
span.multiName {
    font-size: 13pt !important;
    font-weight: 400;
}
.course {
    font-size: 13pt;
    font-weight: 400;
}
span.nameMulti {
    font-size: 13pt !important;
    margin-top: -4px;
    background-color: transparent;
}
.male {
    color: #037;
    font-size: 1.5rem!important;
    position: relative;
    top: 0px;
    background-color: #037;
}
.female {
    color: #e33;
    font-size: 1.5rem!important;
    position: relative;
    top: 0px;
    background-color:#e33 ;
}
.mixedEvent {
    margin-bottom: -10px;
}
.inforHoleWidth {
    /* width: 50%; */
}
.vspar-albatross {
    color: #fbbc04;
    background-color: #fbbc04;
    width: 30px;
    height: 30px;
    display: inline-block;
    margin-bottom: 17px;
    margin-right: 10px;
}
.vspar-eagle {
    color: #3c9933;
    background-color: #3c9933;
    width: 30px;
    height: 30px;
    display: inline-block;
    margin-bottom: 17px;
    margin-right: 10px;
}
.vspar-birdie {
    color: #a52a2a;
    background-color: #a52a2a;
    width: 30px;
    height: 30px;
    display: inline-block;
    margin-bottom: 17px;
    margin-right: 10px;
}
.vspar-bogey {
    color: #1e90ff;
    background-color: #1e90ff;
    width: 30px;
    height: 30px;
    display: inline-block;
    margin-bottom: 17px;
    margin-right: 10px;
}
.vspar-dbogey {
    color: #e07020;
    background-color: #e07020;
    width: 30px;
    height: 30px;
    display: inline-block;
    margin-bottom: 17px;
    margin-right: 10px;
}
.multicourseDot {
    /* font-size: 30px!important; */
    /* position: relative; */
    /* top: 4px; */
    font-size: 1.3rem;
}
.inforBreak {
    margin-bottom: 15px;
    font-weight: 400;
}
.SecondLine {
    margin-bottom: 0px;
    font-weight: 400;
}
.tLogo {
    /* width: 65px; */
    width: 45px;
    margin-top: -5px;
    margin-right: 15px;
}
.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: rgba(0,0,0,.00)!important;
    background-clip: border-box;
    border: 0px solid rgba(0, 0, 0, 0.125);
    border-radius: 0;
    color: #000;
    font-size: 14px;
    height: 250px;
}
@media only screen and (max-width: 768px) {
    .infoBlock {
        display: block;
    }
    .card {
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: rgba(0,0,0,.00)!important;
        background-clip: border-box;
        border: 0px solid rgba(0, 0, 0, 0.125);
        border-radius: 0;
        color: #000;
        font-size: 1rem;
        height: auto;
    }
    .card-body {
        flex: 1 1 auto;
        min-height: 1px;
        padding: 1.25rem;
        padding-top: 30px;
        padding-bottom: 50px;
    }
}
@media only screen and (max-width: 480px) {
    .infoBreak {
        display: grid;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .inforHoleWidth > div {
        width: auto;
        margin-top: 10px;
    }
    .hbhLink {
        /* width: 45px; */
        width: 100%;
    }
    .card {
        font-size: 12px;
    }
    .normalText {
        color: #000;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        margin-left: 20px;
    }
    .strokesColour {
        color: #3c9933 !important;
        font-weight: bold;
        font-style: italic;
        font-size: 12px;
    }
}
::v-deep .B {
  color: #333333;
  /* font-size: 43px !important; */
  font-size:1.3rem !important;
  line-height: .2;
  position: relative;
  top: 6px;
  background-color: #333333;
  width: 5px;
  height: 25px;
  display: flex;
}
::v-deep .Y {
  color: #d8db22;
  /* font-size: 43px !important; */
  font-size:1.3rem !important;
  line-height: .2;
  position: relative;
  top: 6px;
  background-color: #d8db22;
  width: 5px;
  height: 25px;
  display: flex;
}
::v-deep .C {
  color: #1E90FF;
  /* font-size: 43px !important; */
  font-size:1.3rem !important;
  line-height: .2;
  position: relative;
  top: 6px;
  background-color: #1E90FF;
  width: 5px;
  height: 25px;
  display: flex;
}
::v-deep .R {
  color: #BB0000;
  /* font-size: 43px !important; */
  font-size:1.3rem !important;
  line-height: .2;
  position: relative;
  top: 6px;
  background-color: #BB0000;
  width: 5px;
  height: 25px;
  display: flex;
}
::v-deep .G {
  color: #3c9933;
  /* font-size: 43px !important; */
  font-size:1.3rem !important;
  line-height: .2;
  position: relative;
  top: 6px;
  background-color: #3c9933;
  width: 5px;
  height: 25px;
  display: flex;
}
::v-deep .O {
  color: #e07020;
  /* font-size: 43px !important; */
  font-size:1.3rem !important;
  line-height: .2;
  position: relative;
  top: 6px;
  background-color: #e07020;
  width: 5px;
  height: 25px;
  display: flex;
}
::v-deep span.multiText {
    position: relative;
    top: -9px;
    text-transform: capitalize;
    padding-left: 10px;
    color: #000000;
    font-size: 14px;
    font-weight: 400;
    left: 10px;
}
</style>